module.exports = new __parcel__URL__("73091265-3.6b73697f.png").toString();